import { combineReducers } from "redux";

import auth from "./auth";
import general from "./general";
import dashboard from "./dashboard";
import notification from "./notification";
import elements from "./elements";
import elementClassification from "./element-classification";
import boards from "./boards";
import audit from "./audit";
import tracking from "./tracking";
import media from "./media";
import evaluation from "./evaluation";

const reducers = combineReducers({
  auth,
  general,
  dashboard,
  notification,
  elements,
  elementClassification,
  boards,
  audit,
  tracking,
  media,
  evaluation
});

export { reducers };
